/**
 * Converte o `price` da API (PYG por 1 unidade da moeda estrangeira está invertido no payload)
 * para "quanto PYG vale 1 unidade da moeda": 1 / price.
 *
 * Regra de cálculo intermediário com 2 casas decimais:
 * - Olha a 3ª casa decimal; se for <= 5, descarta (trunca) a partir da 3ª;
 * - Se for > 5, arredonda a 2ª casa para cima (+0,01 na parte decimal).
 */
export function computePygPerUnit(priceString: string): number {
  const price = Number(priceString);
  if (!Number.isFinite(price) || price <= 0) {
    return Number.NaN;
  }
  const raw = 1 / price;
  const scaled = Math.floor(raw * 1000 + 1e-9);
  const thirdDigit = scaled % 10;
  const truncatedTwo = Math.floor(scaled / 10) / 100;
  return thirdDigit > 5 ? truncatedTwo + 0.01 : truncatedTwo;
}

/** Formato pt-BR para Guarani (PYG): sem casas decimais. */
export function formatPygPtBr(value: number): string {
  if (!Number.isFinite(value)) {
    return '—';
  }
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
